export const ImgPath = {
    recipeImg: 'https://japa-health-media.s3.us-west-2.amazonaws.com/production/wp-content/uploads/2025/06/02061230/recipe-1.jpg',
    courseImg: 'https://japa-health-media.s3.us-west-2.amazonaws.com/production/wp-content/uploads/2025/04/29055104/bg_1-1-1.png',
    communityImg: 'https://japa-health-media.s3.us-west-2.amazonaws.com/production/wp-content/uploads/2025/06/02064729/community-1.png'
}